const ja = {
  meta: {
    homeTitle: "HAROON TRADING 合同会社 | 日本から、世界へ届ける厳選車両",
    homeDescription:
      "日本国内、そして世界へ。HAROON TRADING 合同会社は、厳選した車両の販売・調達・輸出を行っています。",
    ogLocale: "ja_JP",
  },
  nav: {
    home: "ホーム",
    inventory: "在庫車両",
    sourcing: "車両調達",
    sell: "お車の売却",
    export: "輸出",
    company: "会社概要",
    contact: "お問い合わせ",
    privacy: "プライバシーポリシー",
    legal: "特定商取引法に基づく表記",
  },
  ui: {
    menu: "メニュー",
    close: "閉じる",
    viewAll: "在庫一覧を見る",
    backHome: "トップページへ戻る",
    contactUs: "お問い合わせ",
    toBeProvided: "準備中",
    comingSoon: "準備中",
    error: "現在、車両情報を読み込めません。",
    empty: "新しい車両を準備しております。",
    scroll: "Scroll",
    explore: "サービス",
    company: "会社情報",
    legal: "規約・表記",
    contact: "連絡先",
    email: "メール",
    phone: "電話番号",
    viewDetails: "詳細を見る",
    notFoundTitle: "ページが見つかりません",
    notFoundBody: "お探しのページは存在しないか、移動した可能性があります。",
  },
  hero: {
    brand: "HAROON TRADING",
    title: "日本から、卓越した一台を。",
    subtitle: "日本国内へ、そして世界へ。厳選した車両をお届けします。",
    ctaInventory: "在庫車両を見る",
    ctaSourcing: "車両の調達を依頼",
  },
  featured: { eyebrow: "Featured", title: "厳選車両" },
  latest: { eyebrow: "Latest Inventory", title: "新着車両" },
  sourcing: {
    eyebrow: "車両調達",
    title: "お探しの一台を、日本で。",
    body: "ご希望の条件をお聞かせください。国内市場から条件に合う車両をお探しし、ご提案いたします。",
    steps: [
      { title: "ご希望条件の共有", body: "メーカー、車種、年式、仕様、ご予算などをお知らせください。" },
      { title: "国内市場での車両探索", body: "条件に合う車両を日本全国から探します。" },
      { title: "ご提案・ご検討", body: "車両情報と状態をご報告し、ご判断いただきます。" },
    ],
    cta: "調達を依頼する",
  },
  why: {
    eyebrow: "選ばれる理由",
    title: "確かな目で選び、誠実にお伝えする。",
    items: [
      { title: "厳選した仕入れ", body: "履歴・状態・仕様を確認したうえで、一台ずつ選定しています。" },
      { title: "明確な情報開示", body: "仕様・修復歴・車両状態を、日本語と英語でわかりやすくお伝えします。" },
      { title: "国内販売と海外輸出", body: "国内でのご購入から海外への輸出まで、一貫して対応いたします。" },
    ],
  },
  export: {
    eyebrow: "国内販売・海外輸出",
    title: "日本から、世界へ。",
    japanTitle: "国内",
    japanBody: "日本国内のお客様への販売・納車に対応いたします。",
    worldTitle: "海外",
    worldBody: "海外のお客様向けに、輸出書類の手配から船積みまでサポートいたします。",
    cta: "輸出のご相談",
  },
  company: {
    eyebrow: "会社案内",
    title: "HAROON TRADING 合同会社",
    body: "HAROON TRADING 合同会社は、日本を拠点に自動車の販売・調達・輸出を行う会社です。",
    cta: "会社概要を見る",
    profileTitle: "会社概要",
    rows: {
      name: "会社名",
      corporateNumber: "法人番号",
      representative: "代表社員",
      established: "設立",
      capital: "資本金",
      address: "本店所在地",
      phone: "電話番号",
      business: "事業内容",
      license: "古物商許可",
      website: "Webサイト",
    },
  },
  contactCta: {
    eyebrow: "お問い合わせ",
    title: "まずは、お気軽にご相談ください。",
    body: "ご希望の車両やご質問をお聞かせください。日本語・英語でのお問い合わせを承ります。",
    cta: "お問い合わせ",
  },
  vehicle: {
    ask: "価格お問い合わせ",
    detailsSoon: "車両詳細ページは現在準備中です。",
    notFound: "お探しの車両は現在掲載されておりません。",
    demo: "デモ掲載",
  },
  shell: {
    title: "このページは現在準備中です。",
    body: "公開まで今しばらくお待ちください。",
  },
  pages: {
    inventory: { title: "在庫車両", description: "HAROON TRADINGの在庫車両をご覧いただけます。" },
    sold: { title: "販売済み車両", description: "HAROON TRADINGの販売済み車両です。類似車両のお探しも承ります。" },
    sourcing: { title: "車両調達", description: "ご希望の車両を、日本国内から探してご提案いたします。" },
    sell: { title: "お車の売却", description: "お車の売却に関するご案内です。" },
    export: { title: "輸出", description: "日本から世界各国への車両輸出についてのご案内です。" },
    company: { title: "会社概要", description: "HAROON TRADING 合同会社の会社概要です。" },
    contact: { title: "お問い合わせ", description: "HAROON TRADING 合同会社へのお問い合わせはこちら。" },
    privacy: { title: "プライバシーポリシー", description: "HAROON TRADING 合同会社のプライバシーポリシーです。" },
    legal: { title: "特定商取引法に基づく表記", description: "特定商取引法に基づく表記です。" },
  },
  labels: {
    stockId: "在庫番号",
    make: "メーカー",
    model: "車種",
    grade: "グレード",
    modelYear: "年式",
    registrationYear: "初度登録年",
    price: "車両本体価格",
    mileage: "走行距離",
    bodyType: "ボディタイプ",
    chassisNumber: "車台番号",
    modelCode: "型式",
    engine: "エンジン",
    displacement: "排気量",
    fuel: "燃料",
    transmission: "ミッション",
    drivetrain: "駆動方式",
    aspiration: "過給方式",
    steering: "ハンドル",
    doors: "ドア数",
    seats: "乗車定員",
    exteriorColor: "外装色",
    interiorColor: "内装色",
    dimensions: "全長 × 全幅 × 全高",
    shakenExpiry: "車検満了日",
    repairHistory: "修復歴",
    status: "販売状況",
    market: "販売区分",
    features: "装備",
    condition: "車両状態",
  },
  enums: {
    fuel_type: { petrol: "ガソリン", diesel: "ディーゼル", hybrid: "ハイブリッド", plug_in_hybrid: "プラグインハイブリッド", electric: "電気" },
    transmission: { automatic: "AT", manual: "MT", cvt: "CVT", dct: "DCT" },
    drivetrain: { "2wd": "2WD", "4wd": "4WD", awd: "AWD", fwd: "前輪駆動", rwd: "後輪駆動" },
    steering: { right: "右ハンドル", left: "左ハンドル" },
    repair_history: { none: "なし", yes: "あり", unknown: "不明" },
    status: { draft: "下書き", available: "販売中", reserved: "商談中", sold: "販売済み" },
    market: { japan: "国内販売", export: "輸出", both: "国内・輸出" },
    body_type: { suv: "SUV", sedan: "セダン", coupe: "クーペ", hatchback: "ハッチバック", wagon: "ステーションワゴン", minivan: "ミニバン", convertible: "オープンカー", pickup: "ピックアップトラック", van: "バン", truck: "トラック", kei: "軽自動車", commercial: "商用車" },
    condition_grade: { excellent: "極上", very_good: "良好", good: "標準", fair: "やや難あり", poor: "難あり" },
  },
  footer: { tagline: "日本から、自動車の販売・調達・輸出を。" },
  inventory: {
    tabAvailable: "在庫車両",
    tabSold: "販売済み車両",
    scopeNav: "在庫の区分",
    vehicles: "台",
    showing: "{total}台中 {shown}台を表示",
    loadMore: "さらに表示",
    emptyLabel: "該当なし",
    emptyTitle: "条件に一致する車両が見つかりませんでした。",
    emptyBody: "条件を広げるか、一部の絞り込みを解除してお試しください。",
    clearFilters: "条件をクリア",
    soonLabel: "在庫情報",
    soonTitle: "新着車両を近日公開予定です。",
    soonBody: "現在、掲載車両を準備しております。お探しの車両がございましたら、日本国内からお探しいたします。",
    soonSourcing: "車両探しを依頼する",
    errorTitle: "在庫情報を読み込めませんでした。",
    errorBody: "通信環境をご確認のうえ、再度お試しください。",
    retry: "再読み込み",
  },
  filters: {
    filters: "絞り込み",
    make: "メーカー",
    model: "車種",
    allMakes: "すべてのメーカー",
    allModels: "すべての車種",
    selectMakeFirst: "先にメーカーを選択してください",
    year: "年式",
    from: "下限",
    to: "上限",
    price: "価格",
    min: "下限",
    max: "上限",
    mileage: "走行距離",
    upTo: "{value}以下",
    any: "指定なし",
    body: "ボディタイプ",
    more: "その他",
    fuel: "燃料",
    transmission: "ミッション",
    drivetrain: "駆動方式",
    availability: "販売状況",
    includeSold: "販売済み車両を含める",
    apply: "適用",
    clearAll: "すべてクリア",
    close: "絞り込みを閉じる",
    sort: "並び替え",
    sorts: {
      newest: "新着順",
      price_asc: "価格の安い順",
      price_desc: "価格の高い順",
      sold_recent: "販売日の新しい順",
      oldest: "掲載の古い順",
      updated: "更新順",
      year_desc: "年式の新しい順",
      year_asc: "年式の古い順",
      mileage_asc: "走行距離の少ない順",
      mileage_desc: "走行距離の多い順",
      make_az: "メーカー順（A–Z）",
      make_za: "メーカー順（Z–A）",
    },
    moreFilters: "詳細条件",
    selectedCount: "{n}件選択中",
    showResults: "{n}台を表示",
    clearAll: "すべてクリア",
    remove: "条件を解除",
    displacement: "排気量",
    aspiration: "過給方式",
    exteriorColor: "外装色",
    market: "販売区分",
    equipment: "装備",
    searchEquipment: "装備を検索",
    quick4wd: "4WD / AWD",
    quickTurbo: "ターボ",
  },
  detail: {
    overview: "概要",
    specifications: "主要諸元",
    features: "装備・オプション",
    condition: "車両状態",
    related: "関連車両",
    knownImperfections: "確認済みの傷・不具合",
    conditionLabels: { exterior: "外装", interior: "内装", mechanical: "機関", wheels: "ホイール", tires: "タイヤ" },
    conditionDisclaimer: "車両状態は参考情報であり、検査結果や品質を保証するものではありません。",
    inspected: "HAROON TRADINGにて車両状態を確認済みです。",
    enquire: "お問い合わせ",
    whatsapp: "WhatsApp",
    line: "LINE",
    lineAdd: "LINEで友だち追加",
    share: "共有",
    linkCopied: "リンクをコピーしました",
    viewSimilar: "類似車両を見る",
    findSimilar: "類似車両を探す",
    viewAvailable: "在庫車両を見る",
    soldNote: "この車両は販売済みです。",
    reservedNote: "この車両は現在商談中です。お問い合わせは引き続き承ります。",
    availability: { japan: "国内販売", export: "輸出対応", both: "国内販売・輸出対応" },
    noImages: "画像はありません",
    imageUnavailable: "画像を表示できません",
    previous: "前の画像",
    next: "次の画像",
    openGallery: "全画面で表示",
    viewPhoto: "写真を見る",
    notFoundTitle: "車両が見つかりません",
    notFoundBody: "この車両は掲載を終了したか、URLが正しくない可能性があります。",
    backToInventory: "在庫一覧へ戻る",
    whatsappMessage: "こんにちは。{title}（在庫番号：{stock}）について問い合わせたいです。{url}",
  },
  inquiry: {
    title: "車両のお問い合わせ",
    vehicle: "対象車両",
    name: "お名前",
    country: "国・地域",
    selectCountry: "国・地域を選択",
    email: "メールアドレス",
    phone: "WhatsApp / 電話番号",
    port: "仕向港",
    optional: "任意",
    message: "お問い合わせ内容",
    messagePlaceholder: "ご質問、ご要望、ご都合のよい連絡時間帯など",
    consentPre: "",
    consentLink: "プライバシーポリシー",
    consentPost: "に同意のうえ送信します。",
    submit: "送信する",
    sending: "送信中",
    successTitle: "お問い合わせありがとうございます。",
    successBody: "内容を受け付けました。担当者より追ってご連絡いたします。",
    close: "閉じる",
    errors: {
      required: "入力してください。",
      email: "正しいメールアドレスを入力してください。",
      consent: "プライバシーポリシーへの同意が必要です。",
      tooLong: "入力内容が長すぎます。",
      rate: "お問い合わせが集中しています。しばらくしてから再度お試しください。",
      tooFast: "入力内容をご確認のうえ、もう一度送信してください。",
      invalid: "入力内容に誤りがあります。ご確認のうえ再度お試しください。",
      unavailable: "この車両は現在お問い合わせを受け付けておりません。",
      generic: "送信できませんでした。お手数ですが再度お試しください。",
    },
  },
  price: {
    totalLabel: "支払総額", vehiclePrice: "車両価格", exclTax: "（税抜）", inclTax: "（税込）", vehiclePriceIncl: "車両価格（税込）", vehiclePriceExcl: "車両価格（税抜）", miscFees: "諸費用", conditions: "支払総額の条件", price: "価格", shipping: "輸送費は別途お見積り",
    exportTaxNote: "輸出取引については、条件により消費税の取扱いが異なる場合があります。詳しくはお問い合わせください。",
  },
  form: {
    next: "送信後の流れ", nextSteps: ["担当者が内容を一件ずつ確認いたします。", "ご提案やご質問をメールにてご連絡いたします。", "ご了承いただくまで、契約が成立することはありません。"],
    optional: "任意", sending: "送信中", again: "別の内容を送信する",
    successTitle: "送信ありがとうございます。", successBody: "内容を受け付けました。担当者より追ってご連絡いたします。",
    consentPre: "", consentLink: "プライバシーポリシー", consentPost: "に同意のうえ送信します。",
    name: "お名前", email: "メールアドレス", phone: "WhatsApp / 電話番号", message: "お問い合わせ内容", country: "国・地域", selectCountry: "国・地域を選択", searchCountry: "国・地域を検索", noCountry: "該当する国・地域がありません",
    port: "仕向港", yourDetails: "お客様情報",
    errors: {
      required: "入力してください。", email: "正しいメールアドレスを入力してください。", consent: "プライバシーポリシーへの同意が必要です。",
      tooLong: "入力内容が長すぎます。", number: "正しい数値を入力してください。", yearOrder: "「年式（まで）」は「年式（から）」以降を指定してください。",
      rate: "送信が集中しています。しばらくしてから再度お試しください。", tooFast: "入力内容をご確認のうえ、もう一度送信してください。",
      invalid: "入力内容に誤りがあります。ご確認のうえ再度お試しください。", storage: "写真をアップロードできませんでした。お手数ですが再度お試しください。",
      generic: "送信できませんでした。お手数ですが再度お試しください。",
    },
  },
  sourcingPage: {
    eyebrow: "車両仕入れ代行", title: "ご希望の車両をお探しします",
    intro: "ご希望の車種やご予算などの条件をお知らせください。国内のオークション・販売店・独自のネットワークから、条件に合う車両をご提案いたします。",
    vehicle: "ご希望の車両", make: "メーカー", model: "車種", yearFrom: "年式（から）", yearTo: "年式（まで）", budget: "ご予算（円）", mileageMax: "走行距離の上限（km）",
    delivery: "お届け先", destination: "ご利用予定の地域", japan: "日本国内", export: "海外への輸出",
    messagePlaceholder: "ご希望のボディカラー、グレード、装備などをご記入ください", submit: "仕入れ依頼を送信する",
  },
  sellPage: {
    eyebrow: "車両買取", title: "お車の買取をご希望の方へ",
    intro: "車両情報と写真をお送りください。一台ずつ丁寧に確認し、査定結果をご連絡いたします。",
    vehicle: "車両情報", make: "メーカー", model: "車種", grade: "グレード", year: "年式", mileage: "走行距離（km）", chassis: "車台番号・型式",
    conditionNotes: "車両の状態", conditionPlaceholder: "事故歴・修復歴、キズ、改造の有無、整備記録など",
    askingPrice: "ご希望価格（円）", location: "所在地（都道府県）", photos: "写真",
    photosHint: "最大10枚・JPEG / PNG / WebP / HEIC・1枚25MBまで", addPhotos: "写真を追加", remove: "削除",
    photosTooMany: "写真は10枚まで添付できます。", photosType: "対応していないファイルは除外しました（JPEG / PNG / WebP / HEIC、25MBまで）。",
    submit: "車両情報を送信する",
  },
  contactPage: {
    eyebrow: "お問い合わせ", title: "お問い合わせ", intro: "車両、仕入れ代行、輸出、買取に関するご質問は、こちらのフォームよりお送りください。メールにてご返信いたします。",
    subject: "件名", details: "連絡先", address: "所在地", map: "地図", submit: "送信する",
  },
  exportPage: {
    eyebrow: "輸出", title: "日本からの車両輸出", process: "ご利用の流れ", documents: "必要書類", shipping: "輸送方法",
    examples: "主な仕向地の例",
    eligibilityNote: "輸入の可否、年式制限、ハンドル位置の要件、検査、関税・税金、輸送手段の有無は、仕向地と車両によって異なります。仕向国と港をお知らせいただければ、適用される条件を確認いたします。",
    regions: "仕向地", regionsEmpty: "仕向地ごとの対応については、お問い合わせください。",
    ctaTitle: "まずはお問い合わせください", ctaBody: "ご希望の車両または条件と、仕向地をお知らせください。",
    ctaSourcing: "仕入れを依頼する", ctaContact: "お問い合わせ",
  },
  legalPage: { preparingTitle: "準備中", preparingBody: "このページは現在準備中です。公開まで今しばらくお待ちください。" },
};

export default ja;
